
export default {
  routeImporter: {
    loadRouteFile: 'Importar arquivo',
    failedToLoadFile: 'Falha ao carregar o arquivo selecionado. Certifique-se de que o arquivo não esteja corrompido e que esteja em um dos formatos aceitos',
    acceptedImportTypes: 'Tipos de importação aceitos',
    dictDefaultMessage: 'Solte o arquivo a ser importado aqui ou click para selecionar',
    dictFallbackMessage: 'Navegador não suportado',
    dictFileTooBig: 'Arquivo muito grande',
    dictInvalidFileType: 'Tipo de arquivo inválido',
    dictCancelUpload: 'Cancelar envio',
    dictUploadCanceled: 'envio cancelado',
    dictRemoveFile: 'Remover arquivo'
  }
}
